import { Injectable, inject } from '@angular/core'
import { Action, Store, select } from '@ngrx/store'

import { UsersState } from './users.reducer'
import * as UsersSelectors from './users.selectors'
import { AllProfilesFacade } from 'libs/shared/models/profile/profile.models'

@Injectable({
  providedIn: 'root',
})
export class UsersFacade implements AllProfilesFacade {
  private readonly store = inject(Store<UsersState>)

  loaded$ = this.store.pipe(select(UsersSelectors.selectUsersLoaded))
  allUsers$ = this.store.pipe(select(UsersSelectors.selectAllUsers))
  allProfiles$ = this.store.pipe(select(UsersSelectors.selectAllUsers))
  selectedUser$ = this.store.pipe(select(UsersSelectors.selectEntity))
  count$ = this.store.pipe(select(UsersSelectors.selectCount))
  dataView$ = this.store.pipe(select(UsersSelectors.selectDataView))
  searchHistory$ = this.store.pipe(select(UsersSelectors.selectSearchHistory))
  editCreateLoaded$ = this.store.pipe(select(UsersSelectors.selectEditCreateLoaded))
  saveAndSendInviteLoaded$ = this.store.pipe(select(UsersSelectors.selectSaveAndSendInviteLoaded))
  changePasswordLoaded$ = this.store.pipe(select(UsersSelectors.selectChangePasswordLoaded))
  messageLoaded$ = this.store.pipe(select(UsersSelectors.selectMessageLoaded))
  inviteLoaded$ = this.store.pipe(select(UsersSelectors.selectInviteLoaded))
  createBlockLoaded$ = this.store.pipe(select(UsersSelectors.selectCreateBlockLoaded))

  blocksLoaded$ = this.store.pipe(select(UsersSelectors.selectBlocksLoaded))
  blocksCount$ = this.store.pipe(select(UsersSelectors.selectBlocksCount))
  allBlocks$ = this.store.pipe(select(UsersSelectors.selectAllBlocks))

  dispatch(action: Action): void {
    this.store.dispatch(action)
  }
}
